var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"create-gift-button",on:{"click":_vm.onClick}},[_c('CreateGiftWhite',{staticClass:"create-gift-button__icon"}),_vm._v(" "),_c('span',{staticClass:"create-gift-button__text subhead-bold"},[_vm._v("ギフト作成")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }